import styled from '@emotion/styled'
import Breadcrumb from '../../../../components/common/Breadcrumb'
import { insuranceFamilyForm } from '../../../../constant/path'
import { useScreen } from '../../../../utils/responsive-helper'
import Image from '../../../../components/common/Image'
import Text from '../../../../components/common/Text'
import iconUserGroup from '../../../../assets/images/icons-user-group-green-32-px.svg'
import { FONT_LIGHT_GRAY } from '../../../../constant/colors'
import { useHistory } from 'react-router-dom'
import { useCallback } from 'react'
import {
  useGetEnrollmentPeriod,
  useGetRelatives,
} from '../../../../services/enrollment/enrollment-query'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { pullAt } from 'lodash'
import RelativeList from './RelativeList'
import { useMemo } from 'react'
import { RelativeType } from '../../../../services/enrollment/enrollment-types'
import { useGetEnrollmentYear } from '../..'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: center;
`

// const CustomStyleCard = styled(Card)`
//   display: flex;
//   /* position: relative; */
//   flex-direction: column;
//   width: 100%;
//   padding: 32px;
//   margin-bottom: 24px;
//   ${mobile} {
//     padding: 16px;
//   }
// `

// const ButtonInCardStyle = styled(Button)`
//   width: 364px;
// `

// const ButtonCard = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-top: 32px;
//   width: 100%;
// `

// const CardTopic = styled.div`
//   justify-content: start;
//   align-items: center;
//   display: flex;
//   flex-direction: row;
//   width: 100%;
// `

const Header = styled.div`
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 24px;
`

const IconStyle = styled.div`
  padding-right: 16px;
`

const LayoutTopic = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  width: 100%;
`

const LayoutContentTopic = styled.div`
  display: flex;
  text-align: start;
  position: relative;
  flex-direction: column;
  width: 100%;
`

const EnrollmentInsuranceFamily = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const screen = useScreen()
  const { enrollmentYear } = useGetEnrollmentYear()
  const { data: relatives } = useGetRelatives()
  const { data: enrollmentPeriod } = useGetEnrollmentPeriod()
  const { isMobile } = screen
  const onRelativeForm = useCallback(
    (relativeId: number | undefined, relativeTypeId: number, typeName: string) => {
      history.push(
        insuranceFamilyForm({
          queryParam: {
            relativeTypeId: relativeTypeId,
            relativeId: relativeId,
            typeName: typeName,
          },
          routeParam: {
            benefitYearId: enrollmentPeriod?.benefitYearId!,
          },
        }),
      )
    },
    [enrollmentPeriod?.benefitYearId, history],
  )

  const renderRelativeView = useCallback(
    (relative: RelativeType, index: number) => {
      return (
        <RelativeList
          key={`${index}-${relative.typeId}-${relative.typeName}`}
          relativeType={relative}
          onClickAdd={() => {
            onRelativeForm(undefined, relative.typeId, relative.typeName)
          }}
          hidden={() =>
            relative.maxNumber
              ? relative?.relativeList.length >= relative.maxNumber
                ? true
                : false
              : false
          }
        />
      )
    },
    [onRelativeForm],
  )

  const relativeList = useMemo(
    () => relatives?.map(renderRelativeView),
    [renderRelativeView, relatives],
  )

  return (
    <Layout>
      {!isMobile && (
        <Breadcrumb
          overide={(paths) => {
            // paths.unshift({ label: 'Home', path: '/' })
            pullAt(paths, 5, 6)
            paths[0].label = t('ปรับเปลี่ยนสวัสดิการ')
            paths[1].label = t(`ดูสวัสดิการปี ${enrollmentYear}`)
            paths[2].label = t(`สวัสดิการปี ${enrollmentYear} ของฉัน`)
            paths[3] = {
              label: t('ประกันเพิ่มเติมให้ครอบครัว'),
              path: '',
            }
            return paths
          }}
        />
      )}

      <Header>
        <Text size={28} type="Bold">
          ประกันเพิ่มเติมให้ครอบครัว
        </Text>
      </Header>
      <LayoutTopic>
        <IconStyle>
          <Image src={iconUserGroup} width={32} height={32} />
        </IconStyle>
        <LayoutContentTopic>
          <Text size={24} type="Bold">
            รายชื่อคนในครอบครัวที่จะทำประกันให้
          </Text>
          <Text size={22} color={FONT_LIGHT_GRAY} type="Medium">
            เพื่อความสะดวกรวดเร็วคุณสามารถเพิ่มคนในครอบครัวได้ที่นี่เลย
          </Text>
        </LayoutContentTopic>
      </LayoutTopic>
      {/* 
     พ่อแม่
      */}
      {/* {relativeParentsMemo}
      {relativeMateMemo} */}
      {relativeList}
    </Layout>
  )
}

export default EnrollmentInsuranceFamily
